import React, { useEffect, useState } from "react";
import { Button, Container, Row } from 'react-bootstrap';
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify"

import Header from "../Layout/header";
import Footer from "../Layout/footer";
import { FaArrowRight } from "react-icons/fa6";
import logocircle from "../Assets/logo-circle2.png";
import newsletter from "../Assets/newsletter-image3.png";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa6";
import { DecryptData, HideEmailId, NumberChange, NumberOnly, isEmpty } from "../helper/common";
import { GetuserData, Reactivate, UserNameAction, userLogin } from "../Axios/user.axios";
import config from '../helper/config';
import Subscriber from "../Layout/subscribe";
import { useSelector } from "react-redux";
import OTPInput from "react-otp-input";

const initform = {
    UserName: "",
    EmailId: "",
    Profile: "",
    LoginType: "email",
    TFAEnable: false,
    TFACode: "",
    AntiPhishing: false,
    AntiPhishingCode: "",
    WhiteListUser: [],
};

const initsubmitdata = {
    UserName: '',
    Additional: '',
}

const initname = {
    Password: 'Password',
    ConfirmPassword: 'Confirm Password',
}

export default function EditName() {


    const location = useLocation();
    const navigate = useNavigate()
    const userdata = useSelector((state) => state?.LoginReducer?.User)


    const [passwordType, setPasswordType] = useState("password");
    const [passwordType1, setPasswordType1] = useState("password");
    const [currtoken, SetCurrtoken] = useState('');
    const [focusedfield, SetFocusedField] = useState([]);

    const [formdata, SetFormdata] = useState(initform);
    const [SubmitData, SetSubmitData] = useState(initsubmitdata);
    const [displayname, SetDisplayName] = useState(initname);
    const [Otp, SetOTP] = useState("");
    const [Error, SetError] = useState({});
    const [Type, SetType] = useState('verify');
    const [ChangeType, SetChangeType] = useState(location.pathname?.includes('email') ? "email" : "password");
    const [Timer, SetTimer] = useState({
        Minutes: 0,
        Seconds: 0,
    })
    const [counter, setCounter] = useState(180);
    const [Disabled, SetDisabled] = useState(false)
    const [DisableStatus, SetDiableStatus] = useState(false);
    const [BackendTime, SetBackendTime] = useState(null);


    useEffect(() => {
        let cookie = ("; " + document.cookie)
            .split(`; ${config.cookiename}=`)
            .pop()
            .split(";")[0];
        if (cookie) {
            GetUserProfile(cookie);
        }
        else {
            navigate('/')
        }
    }, [userdata])

    const GetUserProfile = async (cookie) => {
        if (!DisableStatus) {
            SetDiableStatus(true);
            let resp = await UserNameAction({ data: cookie, action: 'getdetail' })
            console.log('UserNameAction_resp', resp)
            if (resp?.status) {
                SetFormdata({ ...resp?.data })
                if (resp?.data?.CurrentTime) {
                }
            }
            else {
                navigate('/');
            }
            SetDiableStatus(false);
        }
    }

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, []);

    useEffect(() => {
        let changetoken = location?.search?.split("?id=")?.[1];
        if (!isEmpty(changetoken)) {
            SetCurrtoken(changetoken);
        }
    }, [location?.search])

    const OnChange = (e) => {
        const { id, value } = e.target;
        // SetError({})
        SetSubmitData({ ...SubmitData, ...{ [id]: value } });
    }

    const Validate = () => {
        let error = {};
        if (isEmpty(SubmitData?.UserName)) {
            error.UserName = "Enter User Name";
        }
        return error
    }

    const Submit = async () => {
        SetDisabled(true);
        let error = Validate();
        if (isEmpty(error)) {
            let senddata = {};
            senddata.action = 'save';
            senddata.UserName = SubmitData?.UserName;
            senddata.Additional = SubmitData?.Additional;
            senddata.EmailId = formdata?.EmailId;

            var Resp = await UserNameAction(senddata);
            console.log('UserNameAction_resp', Resp, senddata)
            if (Resp?.success == 'success') {
                toast.success(Resp.msg, 1000)
                GetUserProfile();
            }
            else {
                toast.error(Resp.msg, 1000);
            }
        }
        else {
            SetError(error);
            toast("Fill the Correct datas", { type: 'error' })
        }
        SetDisabled(false);
    }

    const OnBlurFn = (e) => {
        const { id, value } = e.target;
        let error = Validate();
        Object.keys(error).map((currkey) => {
            if (currkey == id || focusedfield.includes(currkey)) {
            }
            else {
                delete error[currkey];
            }
        })
        if (focusedfield?.includes(id)) {
        }
        else {
            SetFocusedField([
                ...focusedfield,
                ...[id],
            ])
        }
        SetError(error);
    }
    
    return (

        <>

            <div className="forgotpage">

                <Header />
                {
                    // formdata?.Activate == false
                    <section class="section">
                        {
                            isEmpty(formdata?.Request)
                                ?
                                <div className="container font-md">
                                    <div className="container text-center customer-reset-password">
                                        <h2 className="color-brand-1 mb-4">Name Correction</h2>

                                        <form method="POST" class="row" action="">
                                            <div class="col-lg-12">
                                                <div class="form-group mb-4">
                                                    <input class={focusedfield?.includes('UserName') ? (Error?.UserName ? "form-control icon-user is-invalid" : "form-control icon-user is-valid") : "form-control icon-user"} id="UserName" name="email" type="text" placeholder="Your User Name" onChange={(e) => OnChange(e)} onBlur={(e) => OnBlurFn(e)} value={SubmitData?.UserName} />
                                                    {Error?.UserName && <span className="error-msg">{Error.UserName}</span>}
                                                </div>
                                            </div>
                                            <div class="col-lg-12">
                                                <div class="form-group mb-4">
                                                    <textarea class={"form-control icon-user is-valid"} id="Additional" name="email" type="text" placeholder="Add Information If You Like" onChange={(e) => OnChange(e)} value={SubmitData?.Additional}/>
                                                </div>
                                            </div>
                                            <div class="col-lg-12 mb-5">
                                                <button class="btn btn-brand-lg btn-full font-md-bold" type="button" onClick={() => Submit()} disabled={Disabled} >Submit</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                :
                                <div className="container font-md">
                                    <div className="container text-center customer-reset-password w-100">
                                        <h2 className="color-brand-1 mb-4">Already Requested for Name Changing</h2>

                                        <p className="pr-4"> Your Have Already Requested <b> It Will take 2 - 3 days for Action </b></p>

                                    </div>
                                </div>

                        }

                    </section>

                }

                <Subscriber />
                {/* <div className="box-newsletter">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-5 mt-3 col-md-12">
                                <div className="box-image-newsletter">
                                    <div className="">
                                        <img className="img-main" src={newsletter} alt="Image NewsLetter" />
                                        <div className="shape-2 image-1"><img src={logocircle} alt="Icon primary" /></div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12 mt-3">
                                <span className="font-lg color-brand-1">Newsletter</span>
                                <h2 className="color-brand-1 mt-2 mb-15">Subscribe our newsletter</h2>
                                <p className="font-md color-grey-500">By clicking the button, you are agreeing with our Term & Conditions</p>
                                <div className="form-newsletter mt-3 position-relative">
                                    <form action="" className="newsletter-form" novalidate="novalidate">
                                        <input type="email" name="email" placeholder="Enter your email..." />
                                        <button className="btn btn-submit-newsletter" type="submit">
                                            <FaArrowRight />
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}

                <Footer />

            </div>

        </>
    );
}
